module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee76028fc0393bed60a5.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/file.worker.js
// module id = +33B
// module chunks = 39